"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var types_1 = require("../types");
var dom_1 = require("../helpers/dom");
var imageManager_1 = require("./imageManager");
var util_1 = require("../helpers/util");
var DEFAULT_URL = 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7';
var events = ['scroll', 'wheel', 'mousewheel', 'resize', 'animationend', 'transitionend', 'touchmove', 'transitioncancel'];
var THROTTLE_DELAY = 300;
var Lazy = /** @class */ (function () {
    function Lazy(options) {
        this.error = options.error || DEFAULT_URL;
        this.loading = options.loading || DEFAULT_URL;
        this.cache = new Set();
        this.managerQueue = [];
        this.throttleLazyHandler = util_1.throttle(this.lazyHandler.bind(this), THROTTLE_DELAY);
        this.init();
    }
    Lazy.prototype.add = function (el, binding) {
        var src = binding.value;
        var parent = dom_1.scrollParent(el);
        var manager = new imageManager_1.default({
            el: el,
            parent: parent,
            src: src,
            error: this.error,
            loading: this.loading,
            cache: this.cache
        });
        this.managerQueue.push(manager);
        if (dom_1.hasIntersectionObserver) {
            this.observer.observe(el);
        }
        else {
            this.addListenerTarget(parent);
            this.addListenerTarget(window);
            this.throttleLazyHandler();
        }
    };
    Lazy.prototype.update = function (el, binding) {
        var src = binding.value;
        var manager = this.managerQueue.find(function (manager) {
            return manager.el === el;
        });
        if (manager) {
            manager.update(src);
        }
    };
    Lazy.prototype.remove = function (el) {
        var manager = this.managerQueue.find(function (manager) {
            return manager.el === el;
        });
        if (manager) {
            this.removeManager(manager);
        }
    };
    Lazy.prototype.init = function () {
        if (dom_1.hasIntersectionObserver) {
            this.initIntersectionObserver();
        }
        else {
            this.targetQueue = [];
        }
    };
    Lazy.prototype.initIntersectionObserver = function () {
        var _this = this;
        this.observer = new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
                if (entry.isIntersecting) {
                    var manager = _this.managerQueue.find(function (manager) {
                        return manager.el === entry.target;
                    });
                    if (manager) {
                        if (manager.state === types_1.State.loaded) {
                            _this.removeManager(manager);
                            return;
                        }
                        manager.load();
                    }
                }
            });
        }, {
            rootMargin: '0px',
            threshold: 0
        });
    };
    Lazy.prototype.addListenerTarget = function (el) {
        var target = this.targetQueue.find(function (target) {
            return target.el === el;
        });
        if (!target) {
            target = {
                el: el,
                ref: 1
            };
            this.targetQueue.push(target);
            this.addListener(el);
        }
        else {
            target.ref++;
        }
    };
    Lazy.prototype.removeListenerTarget = function (el) {
        var _this = this;
        this.targetQueue.some(function (target, index) {
            if (el === target.el) {
                target.ref--;
                if (!target.ref) {
                    _this.removeListener(el);
                    _this.targetQueue.splice(index, 1);
                }
                return true;
            }
            return false;
        });
    };
    Lazy.prototype.addListener = function (el) {
        var _this = this;
        events.forEach(function (event) {
            el.addEventListener(event, _this.throttleLazyHandler, {
                passive: true,
                capture: false
            });
        });
    };
    Lazy.prototype.removeListener = function (el) {
        var _this = this;
        events.forEach(function (event) {
            el.removeEventListener(event, _this.throttleLazyHandler);
        });
    };
    Lazy.prototype.lazyHandler = function (e) {
        for (var i = this.managerQueue.length - 1; i >= 0; i--) {
            var manager = this.managerQueue[i];
            if (manager.isInView()) {
                if (manager.state === types_1.State.loaded) {
                    this.removeManager(manager);
                    return;
                }
                manager.load();
            }
        }
    };
    Lazy.prototype.removeManager = function (manager) {
        var index = this.managerQueue.indexOf(manager);
        if (index > -1) {
            this.managerQueue.splice(index, 1);
        }
        if (this.observer) {
            this.observer.unobserve(manager.el);
        }
        else {
            this.removeListenerTarget(manager.parent);
            this.removeListenerTarget(window);
        }
    };
    return Lazy;
}());
exports.default = Lazy;
//# sourceMappingURL=lazy.js.map